import { Spinner } from 'react-bootstrap';

const Loading = () => (
  <div className='d-flex justify-content-center my-5'>
    <Spinner animation="border" role="status" className='text-primary'/>
  </div>
);

export default Loading;
